export const PROJECT_NOTIFICATION_TYPE = {
  DEFAULT: 'DEFAULT',
  WARNING: 'WARNING',
};

export const PROJECT_NOTIFICATION_ENTITY_TYPE = {
  PROJECT: 'Project',
  ASSUMPTION: 'Assumption',
  ENGINEERING: 'Engineering',
};
